import { isArray } from "lodash";

import { EntityTypeName, isEntity } from "@ds/model/entity-model";

import { isPlainObject } from "@ds/utils/type-guards/common-guards";

export const createCampaignModel = (options?: Partial<Campaign>): Campaign => ({
  __typename: EntityTypeName.CONTENT_CAMPAIGN,
  id: options?.id || 0,
  project_id: options?.project_id || 0,
  name: options?.name || "",
  description: options?.description || "",
  mixing_strategy: options?.mixing_strategy || "time_slice",
});

export const isCampaign = (obj: unknown): obj is Campaign => {
  return isEntity(obj) && obj.__typename === EntityTypeName.CONTENT_CAMPAIGN;
};

export const isCampaignArray = (obj: unknown): obj is Campaign[] => isArray(obj) && obj.every(isCampaign);

export const isCampaignQueryOutput = (obj: unknown): obj is QueryOutput<Campaign> =>
  isPlainObject(obj) && "items" in obj && isCampaignArray(obj.items);
